import React from "react";
import { useTranslation } from "@/hooks/useTranslation";
import { useLanguage } from "@/contexts/LanguageContext";

interface TProps {
  children: string;
}

/**
 * Translation wrapper component.
 * Usage: <T>Some English text</T>
 * When language is English, renders children directly (zero overhead).
 * When non-English, shows original text then fades in translation.
 */
export const T: React.FC<TProps> = ({ children }) => {
  const { isEnglish } = useLanguage();
  
  if (isEnglish) {
    return <>{children}</>;
  }

  return <TranslatedText text={children} />;
};

const TranslatedText: React.FC<{ text: string }> = ({ text }) => {
  const translated = useTranslation(text);
  return <>{translated}</>;
};
